import React from "react";

import type { Module } from "ee/constants/ModuleConstants";
import { ENTITY_EXPLORER_RENDER_ORDER } from "ee/constants/ModuleConstants";
import ModuleEntity from "./Entity";
import {
  getAllModules,
  getCurrentModuleId,
} from "ee/selectors/modulesSelector";
import { useSelector } from "react-redux";
import {
  EMPTY_MODULES_MSG,
  NEW_MODULE_BUTTON,
  createMessage,
} from "ee/constants/messages";
import { EmptyComponent } from "pages/Editor/Explorer/common";
import { groupModules } from "./utils";
interface ModuleEntitiesProps {
  canCreateModules: boolean;
  packageId: string;
  action: () => void;
  onItemSelected?: () => void;
}

function ModuleEntities({
  action,
  canCreateModules,
  onItemSelected,
  packageId,
}: ModuleEntitiesProps) {
  const currentModuleId = useSelector(getCurrentModuleId);
  const modules = useSelector(getAllModules);
  const { modulesCount, modulesMap } = groupModules({
    modules,
  });

  const renderModule = (module: Module) => {
    return (
      <ModuleEntity
        currentModuleId={currentModuleId}
        key={module.id}
        module={module}
        onItemSelected={onItemSelected}
        packageId={packageId}
      />
    );
  };

  if (modulesCount === 0) {
    return (
      <EmptyComponent
        mainText={createMessage(EMPTY_MODULES_MSG)}
        {...(canCreateModules && {
          addBtnText: createMessage(NEW_MODULE_BUTTON),
          addFunction: action,
        })}
      />
    );
  }

  return (
    <>
      {ENTITY_EXPLORER_RENDER_ORDER.map((type) => {
        return modulesMap[type].map((m) => renderModule(m));
      })}
    </>
  );
}

export default ModuleEntities;
